import React from 'react';
const notImplemented = () => { throw new Error('not implemented'); };
const AboutMeContext = React.createContext({
    getPerson: notImplemented,
    updatePerson: notImplemented,
    sendVerificationLink: notImplemented,
});
export default AboutMeContext;
